import { render, staticRenderFns } from "./DepositoDaEscola.vue?vue&type=template&id=1b84f059&"
import script from "./DepositoDaEscola.vue?vue&type=script&lang=js&"
export * from "./DepositoDaEscola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports